import { motion } from "framer-motion";
import svgStyle from "./audioIcon.module.scss";

export default function AudioIcon(props) {
  const { className } = props;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 40 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <motion.path
        className={svgStyle.path}
        transition={{ duration: 0.3 }}
        d="M40 2.50299C40 1.78843 39.6464 1.11878 39.0527 0.708842C38.4589 0.298901 37.6996 0.200198 37.0183 0.444395L12.5739 9.2063C11.6957 9.52108 11.1111 10.3438 11.1111 11.2649V31.717C10.1008 31.2439 8.97066 30.9792 7.77778 30.9792C3.48223 30.9792 0 34.4117 0 38.6458C0 42.88 3.48223 46.3125 7.77778 46.3125C12.0733 46.3125 15.5556 42.88 15.5556 38.6458C15.5556 38.4048 15.5443 38.1663 15.5222 37.9309C15.5441 37.8074 15.5556 37.6803 15.5556 37.5506V12.7992L35.5556 5.63033V27.336C34.5453 26.8629 33.4151 26.5982 32.2222 26.5982C27.9267 26.5982 24.4444 30.0307 24.4444 34.2649C24.4444 38.4991 27.9267 41.9315 32.2222 41.9315C36.5178 41.9315 40 38.4991 40 34.2649C40 34.0238 39.9887 33.7853 39.9666 33.5499C39.9886 33.4264 40 33.2994 40 33.1697V2.50299Z"
      />
    </svg>
  );
}
